import React from "react";
import { ErrorMessage, Field } from "formik";
import "./Uploads.scss";
import ErrorText from 'components/shared/errortext/ErrorText'
import { ReactComponent as UploadIcon } from "assets/svg/upload.svg";

const Upload = (props) => {
    const { label, name, onChange, newLabel, ref, req, disabled, ...rest } = props;
    return (
        <div className="inputControl">
            <label className="inputControl--input" name={name} {...rest} htmlFor={name}>
                <div className="inputControl--input-label" >
                    <UploadIcon />
                    {newLabel}
                </div>
                <Field name={name}>
                    {
                        ({ field }) => (
                            <input
                                {...field}
                                className="inputControl--input-file"
                                onChange={onChange}
                                type="file"
                                id={name}
                                name={name}
                                ref={ref}
                                disabled={disabled}
                                accept="image/pdf/doc/docx/png/jpeg"
                            />
                        )
                    }
                </Field>
            </label>
            <ErrorMessage
                name={name}
                component={ErrorText}
            />
        </div>
    );
};

export default Upload;
